
import authApi from '../../utils/AxiosConfig';
import authHeader from '../../utils/authHeader';

const API_URL = '/cart';

const getCart = async (token: any) => {
    const response = await authApi.get(API_URL, {
        headers: authHeader(token),
    });
    return response.data;
};

const addToCart = async (cartData: any, token: any) => {
    const response = await authApi.post(API_URL, cartData, {
        headers: authHeader(token),
    });
    return response.data;
};

const removeFromCart = async (cartItemId: string, businessId: string) => {
    const response = await authApi.delete(`${API_URL}/${cartItemId}`, {
        headers: authHeader(),
        data: { businessId }, // Add the businessId in the request body
    });
    return response.data;
};

const cartService = { getCart, addToCart, removeFromCart };
export default cartService;
